import { queryOptions } from '@tanstack/react-query';
import { apiClient } from '@/api/axios';
import { API } from '@/api/endpoints';
import { STALE_TIME } from '@/api/staleTimes';
import {
  pendingSummaryResponseSchema,
  type PendingSummaryResponse,
  type PendingSummarySearch,
} from '../types/pendingSummary.types';

export const pendingSummaryQueryKeys = {
  all: () => ['pending-summary'] as const,
  list: (params: PendingSummarySearch) => [...pendingSummaryQueryKeys.all(), params] as const,
};

export const pendingSummaryQueryOptions = (params: PendingSummarySearch) =>
  queryOptions({
    queryKey: pendingSummaryQueryKeys.list(params),
    queryFn: async (): Promise<PendingSummaryResponse> => {
      const res = await apiClient.get(API.dashboard.pendingSummary, { params });
      return pendingSummaryResponseSchema.parse(res.data);
    },
    staleTime: STALE_TIME,
  });
